<div class="content-unavailable__container">
  <div
    class="content-unavailable__icon"
    [class.content-unavailable__icon--white]="
      style() === contentUnavailableStyleEnum.WHITE
    "
    [class.content-unavailable__icon--white-black]="
      style() === contentUnavailableStyleEnum.WHITE_BLACK
    "
    [inlineSVG]="'../assets/img/icons/error-circle.svg'"
  ></div>

  <div class="content-unavailable__message">
    <div
      class="content-unavailable__label"
      [class.content-unavailable__label--white]="
        style() === contentUnavailableStyleEnum.WHITE
      "
    >
      {{ 'STATICS_ERROR.UNAVAILABLE_LABEL' | translate }}
    </div>
    <div
      class="content-unavailable__description"
      [class.content-unavailable__description--white]="
        style() === contentUnavailableStyleEnum.WHITE
      "
      [class.content-unavailable__description--white-black]="
        style() === contentUnavailableStyleEnum.WHITE_BLACK
      "
    >
      {{ 'STATICS_ERROR.UNAVAILABLE_DESCRIPTION' | translate }}
    </div>
  </div>

  <button
    class="content-unavailable__button button button--filled button--shadow"
    [class.content-unavailable__button--white]="
      style() === contentUnavailableStyleEnum.WHITE
    "
    [class.content-unavailable__button--white-black]="
      style() === contentUnavailableStyleEnum.WHITE_BLACK
    "
    [class.content-unavailable__button--default]="
      style() === contentUnavailableStyleEnum.DEFAULT
    "
    [type]="'button'"
    (click)="emitReloadEvent()"
  >
    {{ 'STATICS_ERROR.RELOAD' | translate }}
  </button>
</div>
